import Store from 'store/store';
import { fire } from 'store/bolt/trackingV2';

// View
Store.on('TRACK_QUIZPHOTOBOOTH_VIEW', (category) => {
	fire('quizphotobooth-view', { category });
});

// Intro
Store.on('TRACK_QUIZPHOTOBOOTH_INPUT_CLICK', (inputName) => {
	fire('quizphotobooth-input-click', { inputName });
});

Store.on('TRACK_QUIZPHOTOBOOTH_NAME_CLICK', () => {
	fire('quizphotobooth-name-click');
});

Store.on('TRACK_QUIZPHOTOBOOTH_LOCATION_CLICK', () => {
	fire('quizphotobooth-location-click');
});

Store.on('TRACK_QUIZPHOTOBOOTH_RANDOMIZER_CLICK', () => {
	fire('quizphotobooth-randomizer-click');
});

Store.on('TRACK_QUIZPHOTOBOOTH_START_CLICK', () => {
	fire('quizphotobooth-start-button-click');
});

// Quiz
Store.on('TRACK_QUIZPHOTOBOOTH_ANSWER_CLICK', ({ questionNum, answer }) => {
	fire('quizphotobooth-answer-click', { questionData: `question-${questionNum}_${answer}` });
});

// Results
Store.on('TRACK_QUIZPHOTOBOOTH_RESULT_REVEAL', (result) => {
	fire('quizphotobooth-result-reveal', { result });
});

Store.on('TRACK_QUIZPHOTOBOOTH_RESULT_SHARE', () => {
	fire('quizphotobooth-result-share-cta');
});

// Photobooth Events
Store.on('TRACK_QUIZPHOTOBOOTH_UPLOAD_OR_TAKE_PHOTO', (action) => {
	fire('quizphotobooth-photo-options-click', { action });
});

Store.on('TRACK_QUIZPHOTOBOOTH_CAMERA_PERMISSIONS', (allowOrDeny) => {
	fire('quizphotobooth-camera-permissions', { allowOrDeny });
});

Store.on('TRACK_QUIZPHOTOBOOTH_CAPTURE_PHOTO', () => {
	fire('quizphotobooth-photo-capture-click');
});

Store.on('TRACK_QUIZPHOTOBOOTH_FLIP_CAMERA', () => {
	fire('quizphotobooth-flip-camera');
});

Store.on('TRACK_QUIZPHOTOBOOTH_RETAKE_OR_CONTINUE', (retakeOrContinue) => {
	fire('quizphotobooth-resize-photo-options-click', { retakeOrContinue });
});

Store.on('TRACK_QUIZPHOTOBOOTH_PINCH_ZOOM', () => {
	fire('quizphotobooth-pinch-zoom');
});

Store.on('TRACK_QUIZPHOTOBOOTH_ZOOM_CLICK', (plusOrMinus) => {
	fire('quizphotobooth-zoom-click', { plusOrMinus });
});

Store.on('TRACK_QUIZPHOTOBOOTH_ROTATE_TWIST', () => {
	fire('quizphotobooth-rotate-twist');
});

Store.on('TRACK_QUIZPHOTOBOOTH_ROTATE_CLICK', (direction) => {
	fire('quizphotobooth-rotate-click', { direction });
});

Store.on('TRACK_QUIZPHOTOBOOTH_CHOOSE_FRAME', (frameId) => {
	fire('quizphotobooth-choose-frame', { frameId });
});

Store.on('TRACK_QUIZPHOTOBOOTH_BROWSER_ERROR_CLICK', (screen, browser) => {
	fire('quizphotobooth-browser-error-screen-click', { screen: `${screen}-error`, browser });
});

// Shareable Events
Store.on('TRACK_QUIZPHOTOBOOTH_RESULT_REVEAL_NO_INTERSTITIAL', () => {
	fire('quizphotobooth-result-share-cta', 'shareable', '-');
});

Store.on('TRACK_QUIZPHOTOBOOTH_CAROUSEL_SWIPE', () => {
	fire('quizphotobooth-share-card-carousel-swipe');
});

Store.on('TRACK_QUIZPHOTOBOOTH_SHARE_CARD_CLICK', (type, format) => {
	fire('quizphotobooth-share-card-click', { type, format });
});

Store.on('TRACK_QUIZPHOTOBOOTH_REDO_CLICK', () => {
	fire('quizphotobooth-redo-click');
});

// MISC
Store.on('TRACK_QUIZPHOTOBOOTH_ERROR_BACK', (screen) => {
	fire('quizphotobooth-error-screen-back', { screen: `${screen}-error` });
});

Store.on('TRACK_QUIZPHOTOBOOTH_LOGO_CLICK', () => {
	fire('quizphotobooth-logo-home');
});